module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon2.d20c8c93.png";